export default __webpack_public_path__ + "static/media/becca.cea558f8.jpeg";